import 'angular';

import { VendorInvoicesStates }                   from './vendor-invoices.states.ajs';
import { VendorInvoiceSerialNumbersCtrl }         from './vendor-invoice.serial-numbers';
import { VendorInvoiceAcquisitionCreditCtrl }     from './vendor-invoice.acquisition-credit';
import { VendorInvoiceAcquisitionCtrl }           from './vendor-invoice.acquisition';
import { VendorInvoiceAttachItemsCtrl }           from './vendor-invoice.attach';
import { VendorInvoiceAttachedVendorInvoiceCtrl } from './vendor-invoice.attached-vendor-invoice';
import { VendorInvoiceCreditsDirective }          from './vendor-invoice.credits.directive';
import { VendorInvoiceCreditsCtrl }               from './vendor-invoice.credits';
import { VendorInvoiceCtrl }                      from './vendor-invoice';
import { VendorInvoiceItemTotalsService }         from './vendor-invoice.item-totals.service';
import { VendorInvoicePaymentsCtrl }              from './vendor-invoice.payments';
import { VendorInvoicePaymentsDirective }         from './vendor-invoice.payments.directive';
import { VendorInvoicePriceAdjustmentCtrl }       from './vendor-invoices.price-adjustment';
import { VendorInvoiceSelectionCtrl }             from './vendor-invoice.selection';
import { VendorInvoiceTotalsService }             from './vendor-invoice.totals.service';
import { VendorInvoicesCtrl }                     from './vendor-invoices';
import { VendorInvoicesService }                  from './vendor-invoices.services';

angular.module('workshop.vendorInvoices', [])
  .config(VendorInvoicesStates)
  .controller('AcquisitionCreditCtrl', VendorInvoiceAcquisitionCreditCtrl)
  .controller('AcquisitionCtrl', VendorInvoiceAcquisitionCtrl)
  .controller('AttachItemsToInvoiceCtrl', VendorInvoiceAttachItemsCtrl)
  .controller('InvoiceAttachedVendorInvoicesCtrl', VendorInvoiceAttachedVendorInvoiceCtrl)
  .controller('PriceAdjustmentCtrl', VendorInvoicePriceAdjustmentCtrl)
  .controller('VendorInvoiceCreditsCtrl', VendorInvoiceCreditsCtrl)
  .controller('vendorInvoiceCtrl', VendorInvoiceCtrl)
  .controller('VendorInvoicePaymentsCtrl', VendorInvoicePaymentsCtrl)
  .controller('VendorInvoicesCtrl', VendorInvoicesCtrl)
  .controller('vendorInvoiceSelectionCtrl', VendorInvoiceSelectionCtrl)
  .controller('VendorInvoiceSerialNumbersCtrl', VendorInvoiceSerialNumbersCtrl)
  .directive('vendorCredits', VendorInvoiceCreditsDirective)
  .directive('vendorInvoicePayments', VendorInvoicePaymentsDirective)
  .factory('VendorInvoice', VendorInvoicesService)
  .factory('VendorInvoiceItemTotals', VendorInvoiceItemTotalsService)
  .factory('VendorInvoiceTotals', VendorInvoiceTotalsService)